interface SetResult {
  home: number
  away: number
}

interface Props {
  history: SetResult[]
  maxSets?: number
  className?: string
}

/**
 * Parziali del «Tabellone TV». Corpi dei testi in px del canvas 1920 (il pannello
 * non scala con `cqi`: la sua larghezza di progetto è 1920): 24 px per i numeri,
 * 18 px per il separatore, che è il floor già applicato al segnapunti compatto.
 * Gli slot dei set non ancora giocati si disegnano **solo se** almeno un set è
 * stato giocato: a 0-0 la barra mostrava cinque trattini a opacità 20%.
 */
export default function SetHistory({ history, maxSets = 5, className = '' }: Props) {
  if (history.length === 0) return null

  return (
    <div data-section="sets" className={`flex items-center gap-2 ${className}`}>
      {history.map((set, i) => {
        const homeWon = set.home > set.away
        return (
          <div key={i} className="flex flex-col items-center gap-1 rounded px-2"
            style={{ background: 'var(--sb-chip-bg, transparent)', border: '1px solid var(--sb-chip-border, transparent)' }}>
            <span className="font-display font-bold tabular-nums leading-none"
              style={{ fontSize: 24, color: homeWon ? 'var(--sb-text, #ffffff)' : 'var(--sb-text-muted, rgba(255,255,255,0.4))' }}>
              {set.home}
            </span>
            <span style={{ fontSize: 18, lineHeight: 1, color: 'var(--sb-text-muted, rgba(255,255,255,0.2))' }}>·</span>
            <span className="font-display font-bold tabular-nums leading-none"
              style={{ fontSize: 24, color: !homeWon ? 'var(--sb-text, #ffffff)' : 'var(--sb-text-muted, rgba(255,255,255,0.4))' }}>
              {set.away}
            </span>
          </div>
        )
      })}
      {/* Slot vuoti solo a partita iniziata: a 0-0 non si disegnano. */}
      {history.length > 0 && Array.from({ length: Math.max(0, maxSets - history.length) }, (_, i) => (
        <div key={`empty-${i}`} className="flex flex-col items-center gap-1 rounded px-2 opacity-40">
          <span className="font-display text-white/40 leading-none" style={{ fontSize: 24 }}>–</span>
          <span className="text-white/20" style={{ fontSize: 18, lineHeight: 1 }}>·</span>
          <span className="font-display text-white/40 leading-none" style={{ fontSize: 24 }}>–</span>
        </div>
      ))}
    </div>
  )
}
